import {useState} from 'react';
import {useFormikContext} from 'formik';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';

import SelectFarmBottomSheet from '../../bottomsheetList/selectFarmBottomSheet';
import FormikLikeInput from '../../../../../../components/formikFileds/likeInput';
import WaterSystemBottomSheet from '../../bottomsheetList/waterSystemBottomSheet';
import {addFormData} from '../../../../../../store/redux/advertisementRegisteration';
import useGetFarmLists from '../../../../../../services/hookService/getFarmLists/useFarmList';
import useGetAllWaterSystem from '../../../../../../services/hookService/getAllWaterSystem/useGetAllWaterSystem';
import FloatingOnlySelectBottomSheet from '../../../../../../module/newShop/advertisementRegisteration/floatingOnlySelectBottomSheet';
import {FromikType, ISrs_type} from '../../../types';

interface IFarmAdditionalMainInfoProps {
  touched: boolean;
  sub_input: IInputsFilter | undefined;
  input: IInputsFilter | undefined;
  input_group: IInputGroupsFilter | undefined;
  srs_type: ISrs_type | undefined;
  setIsEmptyFarmModal?: React.Dispatch<React.SetStateAction<boolean>>;
}

const FarmAdditionalMainInfo = ({
  touched,
  sub_input,
  input,
  input_group,
  srs_type,
  setIsEmptyFarmModal,
}: IFarmAdditionalMainInfoProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {values, errors} = useFormikContext<FromikType>();

  const [openSelectFarmBottomSheet, SetOpenSelectFarmBottomSheet] =
    useState<boolean>(false);
  const [openWaterSystemBottomSheet, SetOpenWaterSystemBottomSheet] =
    useState<boolean>(false);

  const {
    data: farmListData,
    loaderRef,
    isFetchingNextPage,
  } = useGetFarmLists({permission_types: [9]});
  const {waterSystemData} = useGetAllWaterSystem();

  return input_group?.code === 17 && input?.code === 11 ? (
    <div className="flex flex-col gap-3">
      <section>
        <p className="mb-2 color-gray-1 text-md font-medium ">
          مزرعه‌ای که قصد {srs_type?.type === 'rent' ? 'اجاره دادن' : 'فروش'} آن
          را دارید انتخاب کنید.
          <span className="color-red-3">*</span>
        </p>
        <FloatingOnlySelectBottomSheet
          name="farm"
          Placeholder="انتخاب مزرعه"
          wrapperClass="border-gray-700"
          onClick={() => {
            if (farmListData?.length === 0) {
              setIsEmptyFarmModal && setIsEmptyFarmModal(true);
            } else {
              SetOpenSelectFarmBottomSheet(true);
            }
          }}
          //@ts-ignore
          errors={touched && (errors['farm']?.name as string)}
          value={values.farm?.name}
        />
      </section>
      {values.farm && (
        <div className="flex flex-col gap-2">
          <FormikLikeInput
            name="existing"
            label="مساحت مزرعه (هکتار)"
            disabled={values.farm ? true : false}
            required={false}
          />
          <FormikLikeInput
            name=""
            label="نوع زمین"
            touched={touched}
            readOnly={true}
            value={sub_input?.title}
            onClick={() => {
              navigate('/advertisement-register-subInput-list', {
                state: {
                  input: input?.guid,
                  backRoute: '/advertisement-registeration',
                },
              });
              dispatch(addFormData(JSON.stringify(values)));
            }}
          />
          <FloatingOnlySelectBottomSheet
            name="water_system"
            Placeholder="روش آبیاری مزرعه"
            wrapperClass="border-gray-700"
            onClick={() => {
              SetOpenWaterSystemBottomSheet(true);
            }}
            //@ts-ignore
            value={values.water_system?.name}
          />
        </div>
      )}
      <SelectFarmBottomSheet
        {...{
          openSelectFarmBottomSheet,
          SetOpenSelectFarmBottomSheet,
          farmListData,
          loaderRef,
          isFetchingNextPage,
        }}
      />
      <WaterSystemBottomSheet
        {...{
          openWaterSystemBottomSheet,
          SetOpenWaterSystemBottomSheet,
          waterSystemData,
        }}
      />
    </div>
  ) : (
    <></>
  );
};

export default FarmAdditionalMainInfo;
